module.exports = __webpack_public_path__ + "img/logo-mtl-en-commun-cropped.fb0571f7.png";